import { VStack } from "@biblioteksentralen/react";
import { ReactNode } from "react";

export const FooterMenuList = ({ children }: { children: ReactNode }) => (
  <VStack as="ul" opacity="0.8" listStyleType="none" gap="2" alignItems="flex-start">
    {children}
  </VStack>
);
